(function () {
    angular.module('core')
      .service('assignedFocusApi', [
          '$q',
          '$filter',
          '$http',
          '$state',
          'cancelableResourceFactory',
          'cancelableResourceManager',
          'dblAssignmentService',
          'moment',
          'standard',
          'timeframe',
          'transformResponse',
          'standardsApi',
          'profileApi',
          'regmarkService',
          AssignedFocusApi]);

    function AssignedFocusApi(
      $q,
      $filter,
      $http,
      $state,
      $cancelableResourceFactory,
      dblCancelableResourceManager,
      dblAssignmentService,
      $moment,
      $standard,
      $timeframe,
      $transformResponse,
      dblStandardsApi,
      profileApi,
      regmarkService
    ) {

        var self = this;

        self.getClassroomAssignedLessonsHistory = getClassroomAssignedLessonsHistory;
        self.getStudentAssignedLessonsHistory = getStudentAssignedLessonsHistory;
        self.getStudentActiveLessons = getStudentActiveLessons;
        self.getStudentActiveLessonsWithPromise = getStudentActiveLessonsWithPromise;
        self.createAssignment = createAssignment;
        self.create3PAssessmentAssignments = create3PAssessmentAssignments;
        self.appendFocusData = appendFocusData;
        self.cancelClassroomLesson = cancelClassroomLesson;
        self.cancelStudentLesson = cancelStudentLesson;
        self.getProficiencySlots = getProficiencySlots;
        self.determineLessonClass = determineLessonClass;
        self.validateLessonGoalName = validateLessonGoalName;
        self.getSupportedAssignmentType = getSupportedAssignmentType;
        self.isLongTermAssignment = isLongTermAssignment;
        self.isNweaAssignment = isNweaAssignment;
        self.isQuantileAssignment = isQuantileAssignment;
        self.thirdPartyTitle = thirdPartyTitle;
        self.isLegacyNwea = isLegacyNwea;
        self.getActiveThirdPartyAssessment = getActiveThirdPartyAssessment;
        self.createProgressDataFromAssignment = createProgressDataFromAssignment;

        function assignedLessonsMapping(lesson) {
            var assignedLessons = lesson;
            return assignedLessons;
        }

        var AssignedLessonsHistory = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:district_id/classrooms/:classroom_id/assignments', {}, {
            getClassroom: {
                url: '/r/districts/:district_id/classrooms/:classroom_id/assignments',
                method: 'GET',
                transformResponse: function (body) {
                    return $transformResponse.transformAssignmentsQuery(body);
                }
            },
            getStudent: {
                url: '/r/districts/:district_id/students/:student_id/assignments',
                method: 'GET',
                transformResponse: function (body) {
                    return $transformResponse.transformAssignmentsQuery(body);
                }
            }
        });

        var ActiveAssignedLessons = $cancelableResourceFactory.createCacheableResource(null, '/m/assignments/students', {}, {
            getStudents: {
                url: '/m/assignments/students',
                method: 'GET',
                isArray: true,
                transformResponse: function (body) {
                    return $transformResponse.transformAssignmentStatusQuery('active_assignment', body, assignedLessonsMapping);
                }
            }
        });

        var AssignmentResource = $cancelableResourceFactory.createCacheableResource(null, '/m/assignments', {}, {
            create: {
                url: '/m/assignments',
                method: 'POST'
            }
        });

        var UpdateAssignedLesson = $cancelableResourceFactory.createCacheableResource(null, '/m/assignments/:aid', {
            aid: '@aid'
        }, {
            cancel: {
                url: '/m/assignments/:aid',
                method: 'PUT'
            }
        });

        var ProficiencySlots = $cancelableResourceFactory.createCacheableResource(null, '/m/assignments/proficiency_slots', {}, {
            get: {
                url: '/m/assignments/proficiency_slots',
                method: 'GET',
                isArray: false
            }
        });

        /**************************************************************/
        /*                          Helpers                           */
        /**************************************************************/

        // Calculate the reporting from date to use in assignment queries. To prevent missing summer school session data,
        // the lesser of standard reporting year and today minus 3 months is used.
        function calculateReportingDate() {
            var offsetDate = $moment().subtract(3, 'months');
            var standardDate = $moment($timeframe.calculateCurrentReportingYear() + "-07-01");

            if (offsetDate < standardDate) {
                return offsetDate.format('YYYY-MM-DD');
            }

            return standardDate.format('YYYY-MM-DD');
        }

        /**************************************************************/
        /*                          Api                               */

        /**************************************************************/

        function getClassroomAssignedLessonsHistory(page) {
            var params = {
                district_id: $state.params.districtId,
                classroom_id: $state.params.classroomId
            };
            if($state && $state.params && $state.params.groupId){
              params.classroom_id = $state.params.groupId;
           }
            if (page) {
                params.page = page;
            }

            // The default school year, according to G2, is July 1st of the current reporting year.
            params.fd = calculateReportingDate();
            // RM-51406: Removing the to_date to prevent errors caused by using UTC time.
            // params.to_date = $moment().format('YYYY-MM-DD');

            // Default status to ACTIVE,CLOSED to match API behavior
            params.status = 'ACTIVE,CLOSED';

            var resource = AssignedLessonsHistory.getClassroom(params);
            dblCancelableResourceManager.addAndRemoveOnFinish(resource);

            return resource.$promise;
        }

        function getStudentAssignedLessonsHistory(studentId, callback) {
            var district_id = $state.params.districtId !== '-1' ? $state.params.districtId : $state.params.studentDistrictId;

            var params = {
                from_date: calculateReportingDate(),
                district_id: district_id,
                student_id: studentId,
                size: 32000
            };

            var resource = AssignedLessonsHistory.getStudent(params);
            resource.$promise.then(callback);
            return resource;
        }

        function getStudentActiveLessons(studentIds, callback) {
            var params = {
                user_ids: studentIds
            };

            var resource = ActiveAssignedLessons.getStudents(params);
            resource.$promise.then(callback);
            return resource;
        }

        function getStudentActiveLessonsWithPromise(studentIds) {
            var params = {
                user_ids: studentIds
            };

            var resource = ActiveAssignedLessons.getStudents(params);
            return resource.$promise;
        }

        function createAssignment(studentIds, type, durationInWeeks, callback, errorCallback) {

            var focusType = $state.params.focusType;
            var assignmentDates = dblAssignmentService.generateAssignmentDates(durationInWeeks);

            // lessons_assigned    - int, number of lessons to assign
            // start_date/end_date - start date of assignment, end date of assignment  2016-01-31THH:MM:SS  UTC   (ISO time)
            // user_ids[ ]         - (comma separated array of user ids of students in the classroom)
            var params = {
                classroom_id: $state.params.classroomId,
                focus_id: focusType === 'domain' ? $standard.getParams().domain : $standard.getParams().standard,
                focus_type: focusType.toUpperCase(),
                assignment_type: type,
                start_date: assignmentDates.start.format(), // date string with utc offset like "2017-01-30T17:37:58+00:00"
                end_date: assignmentDates.end.format(),
                user_ids: studentIds
            };

            // Only spot lessons have a a number of lessons, which is defaulted to two.
            if (type === 'SPOT') {
                params.lessons_assigned = 2;
            }

            if (params.focus_id) {
                var resource = AssignmentResource.create(params);
                resource.$promise.then(callback).catch(errorCallback);
                return resource;
            }

            return null;
        }

        self.getFocusType = function (item) {
            if (!item) {
                return '';
            }

            if (item.domain) {
                return 'domain';
            } else if (item.cluster) {
                return 'cluster';
            } else {
                return 'standard';
            }
        };

        function create3PAssessmentAssignments(assignments) {
            var focusType = 'DOMAIN';
            var assignmentDates = dblAssignmentService.generateAssignmentDates(10);

            // Consider replacing parallel calls with a batch API
            return _.map(assignments, function (assignment) {
                return AssignmentResource.create({
                    classroom_id: assignment.classroomId,
                    focus_id: assignment.domainId,
                    focus_type: assignment.focusType || focusType,
                    assignment_type: 'GOAL',
                    start_date: assignmentDates.start.format(),
                    end_date: assignmentDates.end.format(),
                    user_ids: [assignment.userId]
                }).$promise;
            });
        }

        /**
         * Looks up data associated with an assignment's focus id and type and appends it to the assignment object
         * @param assignments list of assignments to append focus data to
         * @returns {*|Promise<any>}
         */
        function appendFocusData(assignments) {
            var promises = {};
            _.forEach(assignments, function (assignment) {
                if (assignment.focus_type && assignment.focus_id) {
                    assignment.promiseKey = assignment.focus_type + '-' + assignment.focus_id;
                    promises[assignment.promiseKey] = dblStandardsApi.StandardData.get({
                        focus_type: assignment.focus_type,
                        focus_id: assignment.focus_id
                    }).$promise;
                }
            });

            return $q.all(promises).then(function (result) {
                return _.map(assignments, function (assignment) {
                    if (assignment.promiseKey) {
                        assignment.focusData = result[assignment.promiseKey].data;
                        delete assignment.promiseKey;
                    }
                    return assignment;
                });
            });
        }

        function cancelClassroomLesson(assignment, callback, errorCallback) {
            var params = {
                aid: assignment.assignment_id,
                classroom_id: $state.params.classroomId,
                status: 'CANCELLED'
            };
            if ($state.params.groupId) {
              params.classroom_id = $state.params.groupId;
            }

            if (params.aid) {
                var resource = UpdateAssignedLesson.cancel(params);
                resource.$promise.then(callback).catch(errorCallback);
                return resource;
            }

            return null;
        }

        function cancelStudentLesson(user_ids, assignment, callback, errorCallback) {
            var params = {
                aid: assignment.assignment_id,
                user_ids: user_ids,
                status: 'CANCELLED'
            };

            if (params.aid) {
                var resource = UpdateAssignedLesson.cancel(params);
                resource.$promise.then(callback).catch(errorCallback);
                return resource;
            }

            return null;
        }

        function getProficiencySlots(ft, fid) {
            var params = {
                focus_type: ft,
                focus_id: fid
            };

            var resource = ProficiencySlots.get(params);
            dblCancelableResourceManager.addAndRemoveOnFinish(resource);
            return resource.$promise;
        }

        function determineLessonClass(student_assignment_histories) {
            var result = [];
            for (var i = 0; i < 2; i++) {
                if (student_assignment_histories && student_assignment_histories.length > i) {
                    if (student_assignment_histories[i].was_lesson_passed) {
                        result.push("passed");
                    } else {
                        result.push(student_assignment_histories[i].was_lesson_passed === null ? "incomplete" : "failed");
                    }
                } else {
                    result.push("incomplete");
                }
            }

            return result;
        }

        function validateLessonGoalName(lesson_goal_name) {
            if (lesson_goal_name === null) {
                return 'g09';
            }

            return lesson_goal_name;
        }

        /**
         * Returns a dashboard-supported assignment type given a sequencer-supported assignment type
         *
         * This is useful for assignment types that are generally only meaningful for the sequencer, not necessarily
         * the dashboard.
         *
         * @param assignmentType the assignment type
         * @returns {string}
         */
        function getSupportedAssignmentType(assignmentType) {
            // GOAL_PLAY_PRESUMED_PASSED should be treated as a GOAL as far as the dashboard is concerned, so let's map
            // this assignment type to GOAL.
            return assignmentType === 'GOAL_PLAY_PRESUMED_PASSED' ? 'GOAL' : assignmentType;
        }

        /* Only relevant condition here is `assignment.assignment_type.indexOf('GOAL')`
        * isNweaAssignment and isQuantileAssignment are no longer applicable, backend already handles that. */
        function isLongTermAssignment(assignment) {
            return assignment.assignment_type.indexOf('GOAL') === 0 || isNweaAssignment(assignment) || isQuantileAssignment(assignment);
        }

        function thirdPartyTitle(assignment){
            if(isQuantileAssignment(assignment)) {
                return 'Quantile'+ regmarkService.toString() + ' Framework';
            }

            if(isNweaAssignment(assignment)) {
                return "NWEA®";
            }

            return null;
        }

        function isQuantileAssignment(assignment) {
            return !_.isUndefined(assignment.focusData) && assignment.focusData !== null && _.isString(assignment.focusData.category) && assignment.focusData.category.toLowerCase().indexOf('quantile') >=0 ;
        }

        function isNweaAssignment(assignment) {
            return !_.isUndefined(assignment.focusData) && assignment.focusData !== null && _.isString(assignment.focusData.category) && assignment.focusData.category.toLowerCase().indexOf('nwea') >=0 ;
        }

        function isLegacyNwea(assignment) {
          return !_.isUndefined(assignment.focusData) && assignment.focusData !== null && _.isString(assignment.focusData.category) && assignment.focusData.category.toLowerCase() === 'nwea';
        }

        function getActiveThirdPartyAssessment() {
            var schoolId = $state.params.schoolId;
            var teacherId = $state.params.teacherId;
            var classroomId = $state.params.classroomId || null;

            if (schoolId && teacherId) {
                return profileApi.getCustomerSetting(teacherId, schoolId, classroomId, profileApi.THIRD_PARTY_ASSESSMENT);
            } else {
                return $q.reject("Missing state params");
            }
        }

        function createProgressDataFromAssignment(assignment, student_id) {
            var studentData = student_id ? _.find(assignment.students, {user_id: student_id}) : assignment;

            return {
                student_id: studentData.user_id,
                assignment_id: assignment.assignment_id,
                from_date: $moment(Date.parse(assignment.start_date)).format("YYYYMMDD"),
                to_date: $moment(Date.parse(assignment.end_date)).format("YYYYMMDD"),
                focus_id: assignment.focus_id,
                focus_type: assignment.focus_type,
                focus_concept: assignment.focus_concept,
                focus_description: assignment.focus_description,
                focusData: assignment.focusData,
                assignmentStatus: studentData.assignment_status,
                first_name: studentData.first_name,
                last_name: studentData.last_name,
                teacher_name: studentData.assigned_by,
                classroom_name: assignment.classroom_name,
                lesson_goal_name: assignment.lesson_goal_name,
                isStatusCompleteStruggling: studentData.student_status === 'COMPLETE_STRUGGLING',
                isStatusComplete: studentData.student_status === 'COMPLETE',
                isStatusCompleteForEngagement: studentData.student_status === 'COMPLETE_FOR_ENGAGEMENT',
                isStatusCompleteForDevice: studentData.student_status === 'COMPLETE_FOR_DEVICE',
                isNwea: self.isNweaAssignment(assignment),
                isLegacyNwea: self.isLegacyNwea(assignment)
            };
        }
    }
})();
